/** @format */

import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const pdfGenrateTokenAPI = createAsyncThunk(
  "pdfGenrateToken/fetch",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/pdfEditorToken`
      );
      // console.log(response);
      sessionStorage.setItem("refresh", response?.data?.data?.refresh);
      sessionStorage.setItem("access", response?.data?.data?.access);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const pdfGenrateTokenSlice = createSlice({
  name: "pdfGenrateToken",
  initialState: {
    pdfGenrateTokendata: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.pdfGenrateTokendata = {};
      state.status = STATUSES.IDLE;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(pdfGenrateTokenAPI.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(pdfGenrateTokenAPI.fulfilled, (state, action) => {
        state.pdfGenrateTokendata = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(pdfGenrateTokenAPI.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});
export const { reset } = pdfGenrateTokenSlice.actions;

export default pdfGenrateTokenSlice.reducer;
